import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { injectIntl } from 'react-intl';
import PrevSearchButton from '../SearchBar/PrevSearchButton';

function UMOGalleryHeaderInfo({
  mainDescription,
  umoTotal,
  isLoading,
  selectedUMOIDs,
  isSelectAll,
  intl,
  isSortMode,
}) {
  const selectedUMOIDsCount = selectedUMOIDs.toJS().length;
  return (
    <div className="umo-gallery-header__info">
      {mainDescription ? (
        <p className="umo-gallery-header__lightbox-desc">
          {isSortMode
            ? intl.formatMessage({ id: 'searchResults.sortManually' })
            : mainDescription}
        </p>
      ) : (
        ''
      )}
      <div className="umo-gallery-header__legend font-md-medium">
        {isLoading
          ? intl.formatMessage({ id: 'searchResults.loadingHeader' })
          : (umoTotal ? intl.formatMessage(
              { id: 'searchResults.objectsFoundHeader' },
              { objectsFoundCount: umoTotal || 0 }
            ) : '')
        }
      </div>
      <div className="umo-gallery-header__selected">
        {(isSelectAll && umoTotal > 0) || selectedUMOIDsCount > 0
          ? intl.formatMessage(
              { id: 'searchResults.objectSelected' },
              {
                objectsSelectedCount: isSelectAll
                  ? umoTotal - selectedUMOIDsCount
                  : selectedUMOIDsCount,
              }
            )
          : null}
      </div>
      { umoTotal ? <PrevSearchButton /> : ''}
    </div>
  );
}

UMOGalleryHeaderInfo.propTypes = {
  mainDescription: PropTypes.string,
  umoTotal: PropTypes.number,
  isLoading: PropTypes.bool,
  selectedUMOIDs: PropTypes.instanceOf(List),
  isSelectAll: PropTypes.bool,
  isSortMode: PropTypes.bool,
};

export default injectIntl(UMOGalleryHeaderInfo);
